<p>tenant-settings works!</p>
